import { LtMaxPrice, Update, ValidationResult } from '~/Api/User/ProductGroup/LtMaxPrice';

export enum ActionType {
	request = 'LtMaxPrice.request',
	receive = 'LtMaxPrice.receive',
	requestUpdate = 'LtMaxPrice.requestUpdate',
	receiveUpdate = 'LtMaxPrice.receiveUpdate',
	scheduleUpdate = 'LtMaxPrice.scheduleUpdate',
	prune = 'LtMaxPrice.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	ltMaxPrice: LtMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	groupId: string;
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
	update: Update;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	ltMaxPrice: LtMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| PruneAction;
